import { useMemo } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import useApiProfile from "../hooks/useApiProfile";
import ConfirmDialog from "../component/ui/ConfirmDialog";
import Loading from "../pages/Loading";

export default function AdminGate() {
    const { profile, loading } = useApiProfile();
    const navigate = useNavigate();
    const location = useLocation();

    const canViewAdmin = useMemo(() => {
        if (!profile) return false;
        if (typeof profile.can_view_admin === "boolean")
            return profile.can_view_admin;
        if (profile.admin_role) return profile.admin_role !== "user";
        return false;
    }, [profile]);

    if (loading) return <Loading message="Checking admin access…" />;
    if (canViewAdmin) return <Outlet />;

    const handleExit = () => {
        const fallback = location.state?.from || "/dashboard";
        navigate(fallback, { replace: true });
    };

    return (
        <ConfirmDialog
            open
            title="Admin access required"
            description="You don’t have permission to view the administration area. If you believe this is a mistake, contact your admin."
            confirmText="Go to dashboard"
            cancelText="Close"
            onConfirm={handleExit}
            onCancel={handleExit}
        />
    );
}
